import React, { useEffect, useState } from 'react'
// import PropTypes from 'prop-types';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import "./foodGrid.scss";
import FoodCard from '../food-card/FoodCard';

const FoodGrid = () => {
    const [foods, setFoods] = useState([]);
    const location = useLocation().pathname;
    // console.log(useLocation().pathname);
    useEffect(() => {
        const getCategoryFood = async category => {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${category}`);
            setFoods(response.data.meals);
            // console.log(response.data.meals);
        }

        const getAreaFood = async area => {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?a=${area}`);
            setFoods(response.data.meals);
            // console.log(response.data.meals);
        }

        const getSearchFood = async alphabet => {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/search.php?f=${alphabet}`);
            setFoods(response.data.meals);
            // console.log(response.data.meals);
        }

        if (location.includes('/categories/')) {
            getCategoryFood(location.slice(12));
        }
        
        if (location.includes('/areas/')) {
            getAreaFood(location.slice(7));
        }

        if (location.includes('/alphabets/')) {
            getSearchFood(location.slice(11));
        }


    }, [location])
    return (
        <div className='food-grid'>
            {
                foods.length > 0 &&
                foods.map((food, index) => (
                    <FoodCard key={index} id={food.idMeal} title={food.strMeal} image={food.strMealThumb} />
                ))
            }
        </div>
    )
}
export default FoodGrid